<template>
  <v-container grid-list-md pa-0>
    <div class="e-ejercicio">
      <div class="e-ejercicio-descripcion text-xs-left">
        <p class="instruccion" v-html="textSpanish"></p>
        <div class="e-chat">
          <div class="e-chat-content mt-3">
            <div class="e-chat-content-left" v-if="textMessage2.length > 0">
              <div v-html="textMessage2"></div><br/>
              <small class="grey-light--text pt-2 d-inline-block"></small>
            </div>
            <div class="e-chat-content-right mt-3 text-xs-right">
              <div class="white--text" v-html="textMessage1"></div><br/>
              <small class="grey-light--text pt-2 d-inline-block"></small>
            </div>
          </div>
          <div></div>
        </div>
        <div class="e-ejercicio-descripcion-ejemplo mb-4 mt-3" v-html="textExercise"></div>
      </div>
      <div class="e-ejercicio-ejercicio-respuesta  pt-0 layout-soluciones">
        <draggable @change="updateValue(soluciones)" class="list-group layout-opciones " 
        :list="soluciones" style="height: 100%" group="options">
            <span
              class="list-group-item"
              v-for="(solucion, index) in soluciones"
              :key="`cardSolu-${index}`">
              <v-card class="e-elevation--3 radius">
                <v-card-text class="py-2 px-2">
                  <p class="e-description-middle mb-0 text-xs-center">{{ solucion }}</p>
                </v-card-text>
              </v-card>
            </span>
        </draggable>
      </div>
      <div class="e-ejercicio-ejercicio-opciones  pt-0 mb-3">
        <draggable class="list-group layout-opciones" :list="options" group="options">
          <span class="list-group-item" d-inline-block v-for="(option, index) in options" :key="`cardLine-${index}`">
            <v-card class="e-elevation--3 radius">
              <v-card-text class="py-2 px-2">
                <p class="e-description-middle mb-0 text-xs-center" style="color: #000">{{ option }}</p>
              </v-card-text>
            </v-card>
          </span>
        </draggable>
      </div>
      <v-flex v-if="isIntermedio">
        <v-btn
        block
        round
        large
        router-link
        :to="`/practica/intermedio/${this.idUnidad}/ejercicio/practicaFilaThree`"
        color="primary">
          COMPROBAR
        </v-btn>
      </v-flex>
    </div>
  </v-container>
</template>
<script>
import draggable from 'vuedraggable'

export default {
  name: 'cardDragLineMessage',
  props: {
    idUnidad: {
      type: String
    },
    textSpanish: {
      type: String,
      default: ''
    },
    textExercise: {
      type: String,
      default: ''
    },
    textMessage1: {
      type: String,
      default: ''
    },
    textMessage2: {
      type: String,
      default: ''
    },
    options: {
      type: Array
    },
    answer: {
      type: String,
      default: ''
    },
    isIntermedio: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      seen: true,
      soluciones: []
    }
  },
  components: {
    draggable
  },
  methods: {
    updateValue (soluciones) {
      const respuestaFinal = {
        answer: this.answer,
        userAnswer: soluciones
      }
      this.$emit('clicked', respuestaFinal)
    }
  }
}
</script>
